type Props = {
  requirements: string[];
};

export const SBCRequirements = ({ requirements }: Props) => (
  <div>
    {requirements
      .filter((req) => {
        const trimmed = req.trim();
        return trimmed !== "" && trimmed !== "-";
      })
      .map((req) => (
        <h4 className="text-xs text-dark-tertiary pb-1" key={req}>
          <span>{req.includes("-") ? req : `- ${req}`}</span>
        </h4>
      ))}
  </div>
);
